import { get, post } from "@/utils";

export const GET_SYSTEMCONFIG = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get('/other/config', { act: "system" })
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_BANNER = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/content/slide", { position: "home" })
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const CONTENT_PAGEINFO = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/content/pageinfo", params)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_SHARE = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/other/config", { act: "share" });
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const USER_LEVELAUTH = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/users/levelauth', params)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_AUTH = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/users/levelauth")
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const USER_COUNTRY = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/users/country")
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const YUEBAO_PRODUCT = (params = {}) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/yuebao/product', params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const YUEBAO_ORDER = (params = {}) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/yuebao/order', params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const YUEBAO_TRANSFER_IN = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/yuebao/transfer/in', params)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const USERS_MESSAGE = (params = { page: 1 }) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/users/message', params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const USERS_MESSAGE_READER = (ids) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/users/message/reader', { ids });
    resolve(res)
  } catch (error) {
    reject(error)
  }
})